import { LOGO_URL } from "../siteData";
import { Link } from 'react-router-dom';
export default function SiteFooter() {
  return (
    <footer className="site-footer" id="offices">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo-badge">
            <img src={LOGO_URL} className="footer-logo" alt="Genesys Info X" />
          </div>
          <div className="footer-tag">Driving innovation through collaboration.</div>
        </div>

        <div className="footer-col">
          <h3 className="footer-section-title">Our Offices</h3>
          <div className="footer-office"><h4><span aria-hidden="true">🇺🇸</span> Head Office</h4><address>7712 Bougainvilea Ct<br/>West Palm Beach, FL 33412<br/>United States</address></div>
          <div className="footer-office"><h4><span aria-hidden="true">🇺🇸</span> Corporate Office</h4><address>311 Golf Road, Suite 1000<br/>West Palm Beach, FL 33407<br/>United States</address></div>
          <div className="footer-office"><h4><span aria-hidden="true">🇮🇳</span> Indian Office</h4><address>2nd Floor, Block B, CYBER GATEWAY<br/>Wing 1, Phase 2, HITEC City<br/>Hyderabad, Telangana 500081</address></div>
        </div>

        <div className="footer-col">
          <h3 className="footer-section-title">Contact Us</h3>
          <div className="footer-label">Email</div>
          <a className="footer-link" href="mailto:info@genesysinfox.com">
            info@genesysinfox.com
          </a>
          <div style={{ height: 10 }} />
          <div className="footer-label">Phone</div>
          <a className="footer-link" href="tel:+916309357756">
            +91 6309357756
          </a>
        </div>

        <div className="footer-col">
          <h3 className="footer-section-title">Join Us</h3>
          <div className="footer-label">HR Contact</div>
          <a className="footer-link" href="mailto:hr@genesysinfox.com">
            hr@genesysinfox.com
          </a>
          <br />
          <a className="footer-link" href="mailto:hr@genesysinfox.in">
            hr@genesysinfox.in
          </a>
          <div style={{ height: 10 }} />
          <div className="footer-label">Careers</div>
          <a className="footer-link" href="mailto:careers.in@genesysinfox.com">
            careers.in@genesysinfox.com
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div>© {new Date().getFullYear()} Genesys Info X. All rights reserved.</div>
          <Link className="footer-link" to="/admin">Company login</Link>
          <button className="footer-link" data-cookie-settings onClick={()=>window.dispatchEvent(new CustomEvent("genesys-cookie-settings"))}>Cookie settings</button>
          <button className="footer-link" onClick={()=>window.dispatchEvent(new CustomEvent("genesys-cookie-settings",{detail:"policy"}))}>Cookie policy</button>
          <details className="photo-credits"><summary>Image credits</summary><p>Data center: <a href="https://unsplash.com/photos/aWslrFhs1w4" target="_blank" rel="noreferrer">Taylor Vick / Unsplash</a>. Healthcare: <a href="https://www.pexels.com/photo/team-of-doctors-5452242/" target="_blank" rel="noreferrer">Tima Miroshnichenko / Pexels</a>. Wafer: <a href="https://commons.wikimedia.org/wiki/File:12-inch_silicon_wafer.jpg" target="_blank" rel="noreferrer">Peellden</a>, <a href="https://creativecommons.org/licenses/by-sa/3.0/" target="_blank" rel="noreferrer">CC BY-SA 3.0</a>; displayed with cropping. Additional imagery: <a href="https://www.pexels.com/photo/engineers-working-in-office-3912378/" target="_blank" rel="noreferrer">ThisIsEngineering / Pexels</a>, <a href="https://unsplash.com/photos/blue-circuit-board-jXd2FSvcRr8" target="_blank" rel="noreferrer">Umberto / Unsplash</a>, and <a href="https://www.pexels.com/photo/person-holding-laboratory-flask-2280571/" target="_blank" rel="noreferrer">Chokniti Khongchum / Pexels</a>. Industry imagery is illustrative.</p><p>Product imagery from Pexels: <a href="https://www.pexels.com/photo/students-in-a-classroom-5676667/" target="_blank" rel="noreferrer">Ivan S</a>, <a href="https://www.pexels.com/photo/a-teacher-using-a-laptop-on-her-desk-8423123/" target="_blank" rel="noreferrer">Pavel Danilyuk</a>, <a href="https://www.pexels.com/photo/a-two-engineer-talking-together-8961073/" target="_blank" rel="noreferrer">Mikael Blomkvist</a>, <a href="https://www.pexels.com/photo/woman-uses-calculator-7491011/" target="_blank" rel="noreferrer">RDNE Stock project</a>, and <a href="https://www.pexels.com/photo/woman-in-a-job-interview-4344878/" target="_blank" rel="noreferrer">Edmond Dantès</a>.</p></details>
        </div>
      </div>
    </footer>
  );
}
